import Modal from "../classes/Modal";

function init() {
	const modalTriggers = document.querySelectorAll('.js-modal-trigger');
	modalTriggers.forEach(el => new Modal(el));
};

export default init;